import { render, staticRenderFns } from "./TicketNewView.vue?vue&type=template&id=7a9239a2&"
import script from "./TicketNewView.vue?vue&type=script&lang=js&"
export * from "./TicketNewView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7a9239a2')) {
      api.createRecord('7a9239a2', component.options)
    } else {
      api.reload('7a9239a2', component.options)
    }
    module.hot.accept("./TicketNewView.vue?vue&type=template&id=7a9239a2&", function () {
      api.rerender('7a9239a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/support/TicketNewView.vue"
export default component.exports